

import EditBase from "../EditBase"

class EditPolyline extends EditBase{


    constructor(options) {
        super(options);
    }

    checkHeightPoint() {
        return false;
    }

    initProperty(bool) {
        var $this = this;
        var positionsProperty = new $this.Cesium.CallbackProperty(function () {
            return $this.plot.attrPlot["edit_positions"];
        }, bool);

        this.plot.polyline.positions = positionsProperty;
    }


}

export default EditPolyline;